import {Role} from "@/entities/auth/Role";

export class Account {
    private static rememberYear: number = 100;
    private static rememberHour: number = 1;

    id: number;
    login: string;
    role: Role;
    token: string;
    name: string;
    surname: string;
    fillSurvey: boolean; // Add this property
    expirationDate!: Date;

    constructor(id: number, login: string, role: Role, token: string, name: string, surname: string, fillSurvey: boolean = false) {
        this.id = id;
        this.login = login;
        this.role = role;
        this.token = token;
        this.name = name;
        this.surname = surname;
        this.fillSurvey = fillSurvey; // Initialize it in constructor
    }

    setExpirationDate(rememberMe: boolean): void {
        const now: Date = new Date();
        this.expirationDate = rememberMe
            ? new Date(now.getFullYear() + Account.rememberYear, now.getMonth(), now.getDate(), now.getHours(), now.getMinutes(), now.getSeconds())
            : new Date(now.getFullYear(), now.getMonth(), now.getDate(), now.getHours() + Account.rememberHour, now.getMinutes(), now.getSeconds());
    }

    isExpired(): boolean {
        return this.expirationDate <= new Date();
    }

    prolongExpirationDate(): void {
        const now: Date = this.expirationDate;
        this.expirationDate = new Date(now.getFullYear(), now.getMonth(), now.getDate(), now.getHours() + Account.rememberHour, now.getMinutes(), now.getSeconds());
    }
}